import { tryParseHttpUrl } from './shared';

export function sanitizeUrl(u: string): URL | null {
  const parsed = tryParseHttpUrl(u);
  if (!parsed) return null;

  // Denylist obvious internal hosts
  const denylist = new Set([
    'localhost',
    '127.0.0.1',
    '[::1]',
    '0.0.0.0',
    'metadata.google.internal'
  ]);
  if (denylist.has(parsed.hostname)) return null;

  // Strip trackers
  const toDelete: string[] = [];
  parsed.searchParams.forEach((_v, k) => {
    if (k.toLowerCase().startsWith('utm_') || k.toLowerCase() === 'fbclid') {
      toDelete.push(k);
    }
  });
  toDelete.forEach((k) => parsed.searchParams.delete(k));

  // Normalize trailing slash in pathname
  if (!parsed.pathname) parsed.pathname = '/';

  return parsed;
}


